import includes from "lodash/includes";

import Analytics from "./Analytics";
import ChatStorage from "./ChatStorage";

export default (() => {
    const JWT_TOKEN_KEY = "jwtToken";
    const roleLookups = [
        {
            name: "ROLE_ANONYMOUS",
            value: 0,
        },
        {
            name: "ROLE_CHAT_USER",
            value: 1,
        },
        {
            name: "ROLE_USER",
            value: 2,
        },
        {
            name: "ROLE_INSIDER",
            value: 3,
        },
        {
            name: "ROLE_OPERATIONS",
            value: 4,
        },
        {
            name: "ROLE_ADMIN",
            value: 5,
        },
        {
            name: "ROLE_SUPER_ADMIN",
            value: 6,
        },
    ];

    const getJwtTokenPayload = jwtToken => {
        try {
            return JSON.parse(atob(jwtToken.split(".")[1]));
        } catch (e) {
            Analytics.exception(e);
        }
        return undefined;
    };

    const isJwtTokenExpired = (jwtToken, leeway = 0) => {
        const body = getJwtTokenPayload(jwtToken);
        const timestamp = Math.floor(Date.now() / 1000);

        return body && body.exp + leeway - timestamp < body.refreshTokenWindowInSeconds;
    };

    const getMaxRoleValue = roles => {
        if (!roles || roles.length === 0) {
            return 0;
        }

        const roleValues = roleLookups
            .filter(lookup => includes(roles, lookup.name))
            .map(lookup => lookup.value)
            .sort();

        return roleValues.length ? roleValues.pop() : 0;
    };

    const canUpdateJwtToken = (newToken, oldToken, leeway = 0) => {
        if (!newToken) {
            return false;
        }

        if (!oldToken || isJwtTokenExpired(oldToken, leeway)) {
            return true;
        }

        const newTokenPayload = getJwtTokenPayload(newToken);
        const oldTokenPayload = getJwtTokenPayload(oldToken);
        const newTokenMaxRole = (newTokenPayload && getMaxRoleValue(newTokenPayload.roles)) || 0;
        const oldTokenMaxRole = (oldTokenPayload && getMaxRoleValue(oldTokenPayload.roles)) || 0;

        if (newTokenMaxRole === oldTokenMaxRole && !isJwtTokenExpired(oldToken, leeway)) {
            return false;
        }

        return newTokenMaxRole >= oldTokenMaxRole && newTokenPayload.exp > oldTokenPayload.exp;
    };

    const getJwtToken = () => ChatStorage.getItem(JWT_TOKEN_KEY);

    const setJwtToken = (token, leeway = 0) => {
        const currentToken = getJwtToken();
        if (canUpdateJwtToken(token, currentToken, leeway)) {
            ChatStorage.setItem(JWT_TOKEN_KEY, token);

            return true;
        }

        return false;
    };

    const clearJwtToken = () => ChatStorage.setItem(JWT_TOKEN_KEY, null);

    return {
        isJwtTokenExpired,
        getJwtToken,
        setJwtToken,
        clearJwtToken,
        getMaxRoleValue,
        canUpdateJwtToken,
        getJwtTokenPayload,
        JWT_TOKEN_KEY,
    };
})();
